<template>
	<div v-if="error">
		<ErrorPage
			v-if="error.statusCode === 404"
			:title="String($t('Error_404_notfound_title'))"
			:message="String($t('Error_404_notfound_description'))"
			:action-text="String($t('Error_404_notfound_button'))"
			:is-x-s="isXS"
			@action-clicked="redirectToHome"
		/>
		<ErrorPage
			v-else
			:title="$t('error_request_error')"
			:action-text="String($t('Menu_discover'))"
			:message="error.message"
			:is-x-s="isXS"
			@action-clicked="redirectToHome"
		/>
	</div>
</template>

<script setup lang="ts">
	import { NuxtError } from '#app'
	import { storeToRefs } from 'pinia'
	import { useDeviceStore } from '~/store/device'
	import { HomeNavigation } from './services/navigation/home'

	const deviceStore = useDeviceStore()
	const { isXS } = storeToRefs(deviceStore)

	interface Props {
		error: NuxtError
	}

	defineProps<Props>()

	const redirectToHome = (): void => {
		HomeNavigation.toHome()
	}
</script>
